var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateaPositiveandLastingImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 19.5,
    stroke: "#256BE4",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 36C29.9558 36 36 29.9558 36 22.5C36 15.0442 29.9558 9 22.5 9C15.0442 9 9 15.0442 9 22.5C9 29.9558 15.0442 36 22.5 36ZM24.0543 29.2946H21.3496V23.3499H14.8696V20.8143H21.3496V14.8696H24.0543V20.8143H30.5061V23.3499H24.0543V29.2946Z",
    fill: "#171C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateaPositiveandLastingImpact);
export default __webpack_public_path__ + "static/media/GenerateaPositiveandLastingImpact.47ede86d355327e6b82945dc53088830.svg";
export { ForwardRef as ReactComponent };